import { RestContext } from "msw/lib/types"

export function delay(ctx: RestContext, delay?: number) {
  return ctx.delay(
    delay != null ? delay : process.env.NODE_ENV === "test" ? 0 : 1000
  )
}
